/* eslint-disable no-underscore-dangle */
import isFunction from 'lodash/isFunction';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import differenceWith from 'lodash/differenceWith';
import { CACHE_KEY_HIGHLIGHT_CONFIG, CACHE_KEY_HIGHLIGHT_ENABLE, HIGHLIGHT_COLORS, HIGHLIGHT_DEFAULT_KEYWORDS, } from './contants';
import { Store } from './utils';
import { enable } from './styles';
const NAMESPACE_HIGHLIGHT = 'pv';
export class ChannelHighlightConfig {
    constructor(keywords, opt = { namespace: NAMESPACE_HIGHLIGHT }) {
        this.keywords = keywords;
        this.opt = opt;
    }
    get disabled() {
        const enabled = enable(this.opt.namespace)();
        let disabled;
        if (enabled === undefined) {
            disabled = false;
        }
        else {
            disabled = !enabled;
        }
        return disabled;
    }
    getArrayFormat(bool) {
        let disabled;
        if (bool !== undefined) {
            disabled = !bool;
        }
        else {
            disabled = this.disabled;
        }
        return this.keywords.map(({ color, value = '' }, index) => {
            if (!color) {
                color = HIGHLIGHT_COLORS[index];
            }
            return { value, color, disabled };
        });
    }
}
const _cache_ = {};
export const highlightChannel = ({ namespace = NAMESPACE_HIGHLIGHT, origin }) => {
    const _id_ = `${namespace}-${origin}`;
    if (!_cache_[_id_]) {
        const cache = Store();
        const key = `${namespace}:${CACHE_KEY_HIGHLIGHT_CONFIG}`;
        const keyOfEnable = `analytics:${namespace}:${CACHE_KEY_HIGHLIGHT_ENABLE}`;
        const listeners = {};
        let count = 0;
        _cache_[_id_] = {
            on(fn) {
                if (!isFunction(fn))
                    return;
                const index = count++;
                listeners[index] = fn;
                window.onstorage = (event) => {
                    if (event.oldValue === event.newValue) {
                        return;
                    }
                    const statusChanged = event.key === keyOfEnable;
                    if (event.key === `analytics:${key}`
                        || statusChanged) {
                        const { id } = JSON.parse(event.newValue || '');
                        if (id === origin) {
                            return;
                        }
                        let value;
                        if (statusChanged) {
                            // 禁用/启动 状态变化时，取本地已存储的数据
                            value = cache.get(key);
                        }
                        else {
                            // 配置变化时，取变化的值
                            value = JSON.parse(event.newValue || '');
                        }
                        const { data } = value || {};
                        const config = new ChannelHighlightConfig(data, { namespace });
                        Object.keys(listeners).forEach((key) => {
                            const enable = get(JSON.parse(event.newValue || ''), 'data');
                            const state = statusChanged ? { enable } : undefined;
                            listeners[key](config, state, event);
                        });
                    }
                };
                return () => {
                    delete listeners[index];
                };
            },
            emit(data) {
                const { data: oldData = HIGHLIGHT_DEFAULT_KEYWORDS } = cache.get(key) || {};
                const diff = differenceWith(data, oldData, isEqual);
                if (!diff) {
                    return;
                }
                cache.set(key, { id: origin, data });
            }
        };
    }
    return _cache_[_id_];
};
//# sourceMappingURL=channel.js.map